<template>
  <div class="field is-grouped is-grouped-multiline">
    <div v-for="option in options" class="control mr-20" :key="option.id">
      <b-checkbox v-model="newValue" :native-value="option.id" @input="input" :type="type">
        {{ option.name }}
      </b-checkbox>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CheckboxPicker",
    props: {
      options: {
        type: Array,
        default: null,
      },
      type: {
        type: String,
        default: null,
      },
      value: {
        default: null,
      }
    },
    data() {
      return {
        newValue: [],
      }
    },
    created() {
      this.newValue = this.value
    },
    methods: {
      input() {
        this.$emit('input', this.newValue)
      },
    },
    watch: {
      value(newValue) {
        this.newValue = newValue
      }
    }
  }
</script>

<style scoped>
</style>
